module.exports = __webpack_public_path__ + "static/media/Logo.d709c647.png";